module.exports = __webpack_public_path__ + "static/media/Diona.fb11c57b.png";